import React, { useContext } from 'react';
import { LocationsHero, SEO } from '../../components';
import { GlobalSiteDataContext } from '../../context';
import { graphql } from 'gatsby';
import './locations.css';

function LocationsPage() {
  const siteData = useContext(GlobalSiteDataContext);
  return (
    <main id='locations-page'>
      <LocationsHero siteData={siteData} />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Laser Hair Removal Locations | Find Your Nearest Milan Laser | ${query.name}, ${query.stateAbbrev}`}
      description=" As the nation's largest laser hair removal company, we have convenient locations all over. Click here to find a Milan laser hair removal near you."
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default LocationsPage;
